import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GenericService } from './generic.service';

@Injectable({
  providedIn: 'root'
})

export class VariavelService extends GenericService {

  constructor(http: HttpClient) {
    super(http, 'variavel');
  }

  filter(params): Observable<any> {
    let url = `${this.url_base}/${this.prefixo}/dados-group-data`;

    return this.http.post(url, params);
  }

  group(params): Observable<any> {
    let url = `${this.url_base}/${this.prefixo}/dados-group`;

    return this.http.post(url, params);
  }

  getType(): Observable<any> {
    return this.http.get(`${this.url_base}/${this.prefixo}/tipo`);
  }
  

}
